import {
    Col,
    Container,
    Navbar, NavbarBrand, NavItem, Row
} from 'reactstrap';
import { Link, NavLink } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setShowSettingsModal } from '../../store/slices/appSlice';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import SettingsModal from '../modals/SettingsModal';
import HelpModal from '../modals/HelpModal';
import { fetchInsemDaysHiglightLimits, fetchUserIsAuthorized, fetchUserSettings } from '../../services/homeService';
import SentBarcodesModal from '../modals/SentBarcodesModal';

function Header(props: any) {

    const dispatch = useAppDispatch();
    const { t } = useTranslation('texts');
    const isAuthenticated = useAppSelector((state) => state.login.authenticated);
    const isAuthorized = useAppSelector((state) => state.app.userIsAuthorized);
    const selectedHerd = useAppSelector((state) => state.app.selectedHerd);
    const showHerdSelector = useAppSelector((state) => state.app.showHerdSelector);

    useEffect(() => {
        if (isAuthenticated) {
            if (isAuthorized == null)
                fetchUserIsAuthorized();
            else if (isAuthorized) {
                fetchUserSettings();
                fetchInsemDaysHiglightLimits();
            }
        }

        // eslint-disable-next-line
    }, [isAuthenticated, isAuthorized]);

    return (
        <header className="header-background">
            <Navbar id="navbar.mobilink" className="navbar-expand-sm">
                <NavbarBrand id="navbar.brand.homeicon" tag={Link} to="/">
                    <img width="120" src="./img/ProAgria_logo.png" alt="MobiLink" />
                </NavbarBrand>

                {t("ApplicationName")}

                <Container className="d-inline-flex flex-row-reverse p-2 col">
                    {!isAuthenticated && (
                        <NavItem className="navbar-nav">
                            <NavLink className="text-dark navlink" to="/login">
                                {t("Login.Login")}
                            </NavLink>
                        </NavItem>
                    )}

                    {isAuthenticated && (
                        <MenuOutlinedIcon
                            role="button"
                            onClick={() => dispatch(setShowSettingsModal(true))}
                            fontSize="large"
                        />
                    )}
                </Container>
            </Navbar>

            {selectedHerd != null && !showHerdSelector && (
                <Row>
                    <Col></Col>
                    <Col>{selectedHerd.idkar} {selectedHerd.custName}</Col>
                </Row>
            )}

            <SettingsModal />

            <HelpModal />

            <SentBarcodesModal />
        </header>
    );
}

export default Header;